import { render, staticRenderFns } from "./SchoolInfo.vue?vue&type=template&id=6c5918bc&scoped=true&"
import script from "./SchoolInfo.vue?vue&type=script&lang=js&"
export * from "./SchoolInfo.vue?vue&type=script&lang=js&"
import style0 from "./SchoolInfo.vue?vue&type=style&index=0&id=6c5918bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5918bc",
  null
  
)

export default component.exports